import { useEffect, useState } from 'react';
import Select from 'react-select';
import { useStepsStore } from '../../stores/StepsStore';
import { medicalConditions } from '../../services/MedicalConditions';

const MedicalConditionsFragment = () => {

    const { newCustomerForm, setFormValue } = useStepsStore();

    const [selectedMedicalConditions, setSelectedMedicalConditions] = useState<{ value: string; label: string; }[]>([]);
    const [otherMedicalCondiditions, setOtherMedicalCondiditions] = useState<string>('');

    const [hasOtherMedicalCondidition, setHasOtherMedicalCondidition] = useState(false);
    const handleOtherMedicalConditionsChange = (event: React.ChangeEvent<HTMLInputElement>) => { setHasOtherMedicalCondidition(event.target.checked); };

    useEffect(() => {
        if (newCustomerForm.medical_conditions?.length > 0 || newCustomerForm.medical_conditions_desc) {
            setSelectedMedicalConditions(newCustomerForm.medical_conditions.map((mc) => ({ value: mc, label: mc })));
        }
        if (newCustomerForm.medical_conditions_desc && newCustomerForm.medical_conditions_desc !== '') {
            setOtherMedicalCondiditions(newCustomerForm.medical_conditions_desc);
            setHasOtherMedicalCondidition(true);
        }
    }, [newCustomerForm]);

    useEffect(() => {
        setFormValue('medical_conditions_desc', [], otherMedicalCondiditions ?? '');
        setFormValue('medical_conditions', [], (selectedMedicalConditions ?? []).map(mc => mc.value));
    }, [otherMedicalCondiditions, selectedMedicalConditions]);

    return ( <div className='medical-conditions-wrap'>
                <div className='margin-bottom'>
                    <label className='ncf-title'>Alarm User's Medical Conditions</label>
                </div>
                <div className='custom_select'>
                    <Select
                        options={ medicalConditions.map(t => ({ value: t, label: t }))}
                        value={selectedMedicalConditions}
                        isMulti
                        className='input-ncf full-width margin-top'
                        onChange={(selectedOptions) => { setSelectedMedicalConditions(selectedOptions as any); }}
                    />
                </div>
                <div className='margin-top'>
                    <label className="custom-checkbox">
                        <input type="checkbox"
                            checked={hasOtherMedicalCondidition}
                            onChange={handleOtherMedicalConditionsChange}
                        />
                        <span></span>
                        Other medical conditions not mentioned above
                    </label>

                    {hasOtherMedicalCondidition ?
                        <textarea className='input-ncf full-width margin-top' rows={10} cols={50} value={otherMedicalCondiditions} onChange={(e) => setOtherMedicalCondiditions(e.target.value)} />
                        : ''}
                </div>
            </div>);
};

export default MedicalConditionsFragment;